// Helper function to parse the www-authenticate header
// The format of CAE header is `Bearer authorization_uri="{url}", error="insufficient_claims", claims="{base64}"`
export type Challenges = Record<string, string>;

export type ParseChallenges = (caeHeader: string | undefined) => Challenges | undefined;
export const parseChallenges: ParseChallenges = (caeHeader: string | undefined) => {
  if (!caeHeader || !caeHeader.includes('insufficient_claims')) {
    return undefined;
  }
  const schemeSeparator = caeHeader.indexOf(' ');
  const challenges = caeHeader.substring(schemeSeparator + 1).split(',');

  return challenges.reduce<Challenges>((challengeMap, challenge) => {
    const [key, value] = challenge.split('=');

    return { ...challengeMap, [key.trim()]: decodeURI(value.replace(/['"]+/g, '')) };
  }, {});
};
